import { DisciplineEnum } from '~/apis/ssf';
import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  district: z.coerce
    .number({ message: msg.required })
    .nullable()
    .default(null)
    .transform(n => (n === 0 ? null : n)),
  discipline: z
    .string()
    .min(1, { message: msg.required })
    .transform(s => s as DisciplineEnum),
  competition_type: z.coerce.number({ message: msg.required }),
  age_category: z.coerce.number({ message: msg.required }),
  weight_class: z.coerce.number({ message: msg.required }),
  date: z.string({ message: msg.required }).date(msg.date),
  result: z.number({ message: msg.required }),
});

export type Schema = z.infer<typeof schema>;
